var map = {
	"./auth.json": "../../packages/i18n/src/pl_PL/auth.json",
	"./banners.json": "../../packages/i18n/src/pl_PL/banners.json",
	"./business-meta.json": "../../packages/i18n/src/pl_PL/business-meta.json",
	"./chat/common.json": "../../packages/i18n/src/pl_PL/chat/common.json",
	"./chat/list.json": "../../packages/i18n/src/pl_PL/chat/list.json",
	"./chat/message.json": "../../packages/i18n/src/pl_PL/chat/message.json",
	"./company/admin.json": "../../packages/i18n/src/pl_PL/company/admin.json",
	"./company/common.json": "../../packages/i18n/src/pl_PL/company/common.json",
	"./company/create.json": "../../packages/i18n/src/pl_PL/company/create.json",
	"./company/options.json": "../../packages/i18n/src/pl_PL/company/options.json",
	"./company/page.json": "../../packages/i18n/src/pl_PL/company/page.json",
	"./company/users.json": "../../packages/i18n/src/pl_PL/company/users.json",
	"./errors.json": "../../packages/i18n/src/pl_PL/errors.json",
	"./group-preview.json": "../../packages/i18n/src/pl_PL/group-preview.json",
	"./landing/companies.json": "../../packages/i18n/src/pl_PL/landing/companies.json",
	"./landing/driver.json": "../../packages/i18n/src/pl_PL/landing/driver.json",
	"./landing/exchange.json": "../../packages/i18n/src/pl_PL/landing/exchange.json",
	"./landing/meta.json": "../../packages/i18n/src/pl_PL/landing/meta.json",
	"./landing/private_exchange.json": "../../packages/i18n/src/pl_PL/landing/private_exchange.json",
	"./landing/shared.json": "../../packages/i18n/src/pl_PL/landing/shared.json",
	"./layout.json": "../../packages/i18n/src/pl_PL/layout.json",
	"./modals.json": "../../packages/i18n/src/pl_PL/modals.json",
	"./offer/actions.json": "../../packages/i18n/src/pl_PL/offer/actions.json",
	"./offer/exchange.json": "../../packages/i18n/src/pl_PL/offer/exchange.json",
	"./offer/form/cargo.json": "../../packages/i18n/src/pl_PL/offer/form/cargo.json",
	"./offer/form/common.json": "../../packages/i18n/src/pl_PL/offer/form/common.json",
	"./offer/form/options.json": "../../packages/i18n/src/pl_PL/offer/form/options.json",
	"./offer/form/transport.json": "../../packages/i18n/src/pl_PL/offer/form/transport.json",
	"./offer/matches.json": "../../packages/i18n/src/pl_PL/offer/matches.json",
	"./offer/my.json": "../../packages/i18n/src/pl_PL/offer/my.json",
	"./offer/own.json": "../../packages/i18n/src/pl_PL/offer/own.json",
	"./offer/preview.json": "../../packages/i18n/src/pl_PL/offer/preview.json",
	"./offer/shared.json": "../../packages/i18n/src/pl_PL/offer/shared.json",
	"./offer/view.json": "../../packages/i18n/src/pl_PL/offer/view.json",
	"./placeholders.json": "../../packages/i18n/src/pl_PL/placeholders.json",
	"./profile/black_list.json": "../../packages/i18n/src/pl_PL/profile/black_list.json",
	"./profile/contact_list.json": "../../packages/i18n/src/pl_PL/profile/contact_list.json",
	"./profile/edit_profile.json": "../../packages/i18n/src/pl_PL/profile/edit_profile.json",
	"./profile/fill_profile.json": "../../packages/i18n/src/pl_PL/profile/fill_profile.json",
	"./profile/my_profile.json": "../../packages/i18n/src/pl_PL/profile/my_profile.json",
	"./profile/my_profile_auth.json": "../../packages/i18n/src/pl_PL/profile/my_profile_auth.json",
	"./profile/profile_form.json": "../../packages/i18n/src/pl_PL/profile/profile_form.json",
	"./profile/shared.json": "../../packages/i18n/src/pl_PL/profile/shared.json",
	"./profile/short_profile.json": "../../packages/i18n/src/pl_PL/profile/short_profile.json",
	"./shared.json": "../../packages/i18n/src/pl_PL/shared.json",
	"./ui.json": "../../packages/i18n/src/pl_PL/ui.json",
	"./validation.json": "../../packages/i18n/src/pl_PL/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/i18n/src/pl_PL sync recursive \\.json$";